import Raven from 'raven-js';
import config from './config';

Raven.config(config.sentry.configUrl, {
  release: config.version,
}).install();

Raven.setTagsContext({
  version: config.version,
});

const isError = x => x instanceof Error;

window.addEventListener('unhandledrejection', event => {
  const reason = event.reason;
  const message = isError(reason) ? reason.message : reason;
  const extra = { message };
  const stack = isError(reason) && reason.stack;

  if (stack) {
    extra.stack = stack;
  }

  const err = new Error(`Unhandled promise rejection: ${message}`);
  Raven.captureException(err, { extra });
});

export default Raven;



// WEBPACK FOOTER //
// ./src/sentry.js